/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_WorkInputs */

const da_privacy_data_work = /** @type {(inputs: Privacy_Data_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Opgaver og besvarelser:** opgavesæt, rettevejledninger og konverteringstabeller, du uploader, elevbesvarelser som PDF, AI-forslag til point, karakter og feedback samt dine egne rettelser og kommentarer. Elevernes navne dækkes i din browser, før en besvarelse sendes til os.`)
};

/** @type {(inputs: Privacy_Data_WorkInputs) => LocalizedString} */
const en_privacy_data_work = da_privacy_data_work;

/**

* @param {Privacy_Data_WorkInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_data_work = /** @type {((inputs?: Privacy_Data_WorkInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_WorkInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_data_work(inputs)
	return /** @type {LocalizedString} */ ("**Opgaver og besvarelser:** opgavesæt, rettevejledninger og konverteringstabeller, du uploader, elevbesvarelser som PDF, AI-forslag til point, karakter og feedback samt dine egne rettelser og kommentarer. Elevernes navne dækkes i din browser, før en besvarelse sendes til os.")
});